import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Table, Button, Radio } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import SideNav from '../SideNav';
import Filter from './Filter';
import ExportUtil from '../../../common/ExportUtil';

const RadioGroup = Radio.Group;

class ExportModal extends Component {
    state = {
        data: {},
        visible: false,
    }

    show = (data) => {
        this.setState({
            data,
            visible: true,
        });
    }

    handleOk = () => {
        const { data } = this.state;
        if (!data.exportType) {
            message.warning('请选择要导出内容');
            return;
        }

        const url = API_URL.competeCompany.exportCompanyCompare;
      
        ExportUtil.export(data, null, url);
        this.cancel();
    }

    cancel = () => {
        this.setState({ visible: false });
    }

    handleChange = (e, key) => {
        const { data } = this.state;
        data[key] = e.target.value;
        this.setState({ data });
    }

    render () {
        const { visible, data: { exportType } } = this.state;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.cancel}
                className="create-modal"
                maskClosable={false}
                width="400px"
            >
                <div className="cont-cont" style={{ padding: 20 }}>
                    <div className="item" >
                        <label className="ui-label">请选择津石与竞争公司对比的导出方式：</label>
                    </div>
                    <div className="item">
                        <RadioGroup onChange={e => this.handleChange(e, 'exportType')} value={exportType}>
                            <div style={{marginTop:15}}><Radio value="FilterRandomCompare">筛选入组数对比</Radio></div>
                            <div style={{marginTop:15}}><Radio value="RandomRate">入组速率对比</Radio></div>
                        </RadioGroup>
                    </div>
                </div>
            </Modal>
        )
    }
}

class Compare extends Component {
    constructor(props) {
        super(props);
        const { settlementType } = props;
        this.state = {
            sortParams: {},
            searchParams: {
                settlementType,
            },
            pagination: {
                current: 1,
                pageSize: 10,
            },
            loading: false,
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.settlementType !== prevProps.settlementType) {
            const { searchParams } = this.state;
            searchParams.settlementType = this.props.settlementType;
            this.setState({ searchParams }, () => {
                this.loadData();
            });
        }
    }

    loadData = () => {
        const { invId } = sessionStorage;
        const { sortParams, searchParams, pagination, pagination: { current, pageSize } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.competeCompany.queryCompanyCompare,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                investigationId: invId,
                ...sortParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { totalCount = 0, datas = [] } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination = {} } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams, sortParams } = this.state;
        this.exportRef.show({...searchParams, ...sortParams});
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            width: 60,
        }, {
            title: '公司名称',
            dataIndex: 'companyName',
            width: 120,
        }, {
            title: '实际启动总site数',
            dataIndex: 'actualStartSiteAmount',
            key: 'actualStartSiteAmount',
            width: 110,
        }, {
            title: '实际入组总数',
            dataIndex: 'actualRandomAmount',
            key: 'actualRandomAmount',
            width: 110,
        }, {
            title: '累计筛选病例数',
            dataIndex: 'filterAccount',
            key: 'filterAccount',
            sorter: true,
            width: 120,
        }, {
            title: '累计随机病例数',
            dataIndex: 'randomAccount',
            key: 'randomAccount',
            sorter: true,
            width: 120,
        }, {
            title: '中心数',
            dataIndex: 'siteCount',
            key: 'siteCount',
            sorter: true,
            width: 100,
        }, {                                                                                                  
            title: '已启动中心数',
            dataIndex: 'siteStartNum',
            key: 'siteStartNum',
            sorter: true,
            width: 120,
        }, {
            title: '平均每家中心随机数',
            dataIndex: 'avgRandomAccount',
            key: 'avgRandomAccount',
            sorter: true,
            width: 160,
        }, {
            title: '本月筛选数',
            dataIndex: 'monthFilterAccount',
            key: 'monthFilterAccount',
            sorter: true,
            width: 120,
        }, {
            title: '本月随机数',
            dataIndex: 'monthRandomAccount',
            key: 'monthRandomAccount',
            sorter: true,
            width: 120,
        }, {
            title: '本周筛选数',
            dataIndex: 'weekFilterAccount',
            key: 'weekFilterAccount',
            sorter: true,
            width: 100,
        }, {
            title: '本周随机数',
            dataIndex: 'weekRandomAccount',
            key: 'weekRandomAccount',
            sorter: true,
            width: 100,
        }];
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;

        let key = 0, idx = 1;
        const dataSource = [];
        if (data && data.length > 0) {
            data.map(item => {
                if (item.companyName == '合计') {
                    dataSource.push({
                        key: key++,
                        index: '合计',
                        ...item,
                    });
                } else {
                    dataSource.push({
                        key: key++,
                        index: idx++,
                        ...item,
                    });
                }
            });
        }
        return dataSource;
    }
    
    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    render() {
        const { loading, pagination, searchParams } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='compare' />
                <div className="main">
                    <Filter
                        search={this.search}
                        params={searchParams}
                        onChange={this.handleFilterChange}
                        buttons={[
                            <Button key="export" type="primary" onClick={this.export}>导出</Button>
                        ]}
                    />
                    <Table
                        bordered
                        loading={loading}
                        scroll={{ x: 1240 }}
                        rowKey={row => row.key}
                        pagination={pagination}
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        onChange={this.handleTableChange}
                    />
                    <ExportModal ref={el => this.exportRef = el} />
                </div>           
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { inProjectState: { settlementType } } = state;
    return {
        settlementType,
    };
};

export default connect(mapStateToProps, null)(Compare);


// WEBPACK FOOTER //
// ./src/components/competeCompany/Compare/index.js